import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { getStylesAddDialog, useAddRefDialog } from './referralStyles';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import clsx from 'clsx';
import { ReferredToService } from '../../../../controls/agyle/ecds';
import moment from 'moment/moment';
import AgyleSelectField from '../../../../components/ui/selector/agyleSelectField';
import { ECDS_VERSION } from '../formsUtil';
import { isEmpty } from 'lodash';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import AgyleDatePicker from '../../../../components/ui/fields/agyleDatePicker';
import config from '../../../../app/config';
import { calculateArrivalDate } from '../../../../util/patientUtil';
const AddReferralDialog = (props) => {
    const theme = useTheme();
    const classes = useAddRefDialog(theme);
    const styles = getStylesAddDialog(theme);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const { t } = useTranslation();
    const { open, onClose } = props;
    const initialDataForm = {
        id: null,
        service: null,
        priority: 'Routine',
        requestTimestamp: moment(),
        assessmentTimestamp: null,
        reason: '',
        initalNote: '',
        acknowledge: false,
    };
    const [dataForm, setDataForm] = useState(initialDataForm);

    const changeHandler = (event) => {
        const value = event.target.value;

        if (props.checkLenght(6, 18, value)) {
            setDataForm((prevState) => ({ ...prevState, service: value }));
        }
    };

    useEffect(() => {
        if (open) {
            setDataForm(initialDataForm);
        }
    }, [open]);

    const setDataFromDictionary = (data) => {
        changeHandler({
            target: {
                name: data[0],
                value: data?.[1] || null,
            },
        });
    };

    const saveReferral = () => {
        if (props.onSave(dataForm)) {
            onClose();
        }
    };

    useEffect(() => {
        setSubmitDisabled(dataForm.service === null || isEmpty(dataForm.priority) || isEmpty(dataForm.reason?.trim()));
    }, [dataForm.service, dataForm.priority, dataForm.reason]);

    const formContext = true; //to do check and remove
    return (
        <AgyleDialog
            open={open}
            onClose={onClose}
            onSave={saveReferral}
            width="md"
            fullWidth
            closeButtonOnHeader
            titleStyle={clsx(classes.backgroundOverride, classes.title)}
            actionStyle={classes.backgroundOverride}
            contentStyle={clsx(classes.backgroundOverride, classes.actionNoDivider, classes.maxHeight)}
            title={t('Add Referral Record')}
            submitText={t('Submit Referral')}
            disableSubmit={submitDisabled}
        >
            <Typography sx={styles.sectionTitle}>REFERRAL DETAILS</Typography>

            <Grid container spacing={2.5}>
                <Grid item xs={12} md={6}>
                    <ReferredToService
                        label={t('Referrals to Service')}
                        onChange={(_e, val) => setDataFromDictionary(['ReferredToService_SnomedCt', val])}
                        error={dataForm.service === null}
                        value={dataForm.service}
                        size="small"
                        noBorder={false}
                        admitDate={props.patient?.admission?.startDate}
                        noBorder={!formContext}
                        withNewBackground={formContext}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <AgyleSelectField
                        label={t('Priority')}
                        onChange={(val) => setDataForm((prevState) => ({ ...prevState, priority: val }))}
                        options={[
                            { id: 'Routine', name: t('Routine') },
                            { id: 'Urgent', name: t('Urgent') },
                            { id: 'Emergency', name: t('Emergency') },
                        ]}
                        value={dataForm.priority}
                        noBorder={false}
                        withNewBackground
                        fullWidth
                        size="small"
                        clearButtonVisible={false}
                        error={isEmpty(dataForm.priority)}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography sx={styles.label}>{t('Reason for Referral *')}</Typography>
                    <AgyleTextField
                        fullWidth
                        name="reason"
                        maxRows={25}
                        minRows={2}
                        multiline
                        value={dataForm.reason}
                        onChange={(event) => setDataForm((prevState) => ({ ...prevState, reason: event.target.value }))}
                        variant="outlined"
                        noBorder={false}
                        withNewBackground
                        error={isEmpty(dataForm.reason?.trim())}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <AgyleDatePicker
                        type="dateTime"
                        inputFormat={config.defaultDateTimeFormat}
                        label={t('Request Date & Time *')}
                        error={!dataForm.requestTimestamp}
                        value={dataForm.requestTimestamp}
                        onChange={(event) => {
                            setDataForm((prevState) => ({ ...prevState, requestTimestamp: event }));
                        }}
                        size="large"
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography sx={styles.optionalSectionTitle}>{t('INITIAL NOTE (OPTIONAL)')}</Typography>
                    <AgyleTextField
                        fullWidth
                        name="initalNote"
                        maxRows={25}
                        minRows={2}
                        debounce
                        multiline
                        value={dataForm.initalNote}
                        onChange={(event) => setDataForm((prevState) => ({ ...prevState, initalNote: event.target.value }))}
                        variant="outlined"
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            </Grid>
        </AgyleDialog>
    );
};

export default AddReferralDialog;
